import { ChevronLeft, ChevronRight } from "lucide-react";

import Touchable from "../../../components/ui/Touchable";
import cn from "../../../utils/cn";

export default function FlipBookNav({
  page,
  isFlipping,
  onPrev,
  onNext,
  className,
}: {
  page: number;
  isFlipping: boolean;
  onPrev: () => void;
  onNext: () => void;
  className?: string;
}) {
  const activeStyle = "bg-[#FED241] text-black8";
  const inactiveStyle = "bg-[#959191]/30 text-[#959191]";

  return (
    <div className={cn("z-10 flex gap-3", className)}>
      <Touchable
        className={cn(
          page === 2 && !isFlipping ? activeStyle : inactiveStyle,
          "flex size-9 items-center justify-center rounded-full",
        )}
        onClick={onPrev}
      >
        <ChevronLeft />
      </Touchable>
      <Touchable
        className={cn(
          page === 1 && !isFlipping ? activeStyle : inactiveStyle,
          "flex size-9 items-center justify-center rounded-full",
        )}
        onClick={onNext}
      >
        <ChevronRight />
      </Touchable>
    </div>
  );
}
